<template>
    <div class="records-wrapper">
        <Head :title="$tc('header.records')"/>
        <Banner v-if="isLoaded && !recordsData"/>
        <div class="records-inner" v-if="isLoaded && !emptydata">
            <!-- 大会未开始 -->
            <div class="records-not-start" v-if="status === 0">{{$tc('footprint.nostart')}}</div>
            <!-- 用户未登录 -->
            <div class="records-notice" v-else-if="!userInfo">
                <p>{{$tc('footprint.sign')}}</p>
                <a href="javascript:;" @click="goLogin">{{$tc('footprint.login')}}</a>
            </div>
            <!-- 没有观展足迹 -->
            <div class="records-notice" v-else-if="!recordsData">
                <p>{{$tc('footprint.nodata')}}</p>
                <a :href="yzgUrl">{{$tc('footprint.Watchexhibition')}}</a>
            </div>
            <!-- 有参展足迹 -->
            <Content :recordsdata="recordsData" v-else/>
        </div>
        <Empty :emptydata="emptydata" v-if="emptydata"/>
    </div>
</template>

<script>

import Banner from '@/components/Banner.vue'
import Content from '@/components/Footprint/Content.vue'
import Footer from '@/components/Footprint/Footer.vue'

import Config from '@/utils/config'

import { mapState, mapMutations } from 'vuex'

export default {
    name: 'Footprint',
    data () {
        return {
            emptydata: null,
            yzgUrl: Config.yzgUrl,
            status: 1,
            recordsData: null,
            isLoaded: false
        }
    },
    components: {
        Banner,
        Content,
        Footer
    },
    computed: {
        ...mapState(['lang', 'userInfo'])
    },
    created () {
        this.getData()
    },
    mounted () {
        this.$nextTick(() => {
            this.$Common.pageShare()
        })
    },
    methods: {
        ...mapMutations(['setShowLoading', 'setUserInfo']),
        getData () {
            const deviceId = this.$Common.getDeviceId()
            this.$Api.getVisitorInfo({
                param: JSON.stringify({
                    device_id: deviceId
                })
            }).then((data) => {
                if (data && (data.visitExhibitionAreaCount || data.visitPavilionCount)) {
                    this.recordsData = data
                }
                this.isLoaded = true
                this.setShowLoading(false)
            }).catch((err) => {
                if (err === 410) {
                    this.status = 0
                } else if (err === 403) {
                    localStorage.removeItem('userInfo')
                    this.setUserInfo('')
                } else {
                    this.emptydata = {
                        type: 'nonetwork'
                    }
                }
                this.isLoaded = true
                this.setShowLoading(false)
            })
        },
        goLogin () {
            this.$router.replace({
                path: '/login',
                query: {
                    lan: this.lang,
                    redirectUrl: window.location.href
                }
            })
        }
    }
}
</script>

<style lang="scss">
    .records-wrapper {
        .empty-wrapper {
            height: auto;
        }
    }
    .records-inner {
        .records-not-start {
            font-size: 3.889vw;
            color: #848585;
            line-height: 1.4;
            padding: 4.63vw;
            text-align: center;
        }
        .records-notice {
            text-align: center;
            padding: 5.556vw 4.63vw 7.222vw;
            p {
                color: #0B0B0B;
                font-size: 3.889vw;
                line-height: 1.4;
                text-align: center;
                margin-bottom: 2.315vw;
            }
            a {
                font-size: 4.444vw;
                color: #fff;
                font-weight: bold;
                text-decoration: none;
                min-width: 34.444vw;
                display: inline-flex;
                height: 9.074vw;
                padding: 0 4.63vw;
                background: linear-gradient(139deg,#2E76F3,#3f55c2);
                justify-content: center;
                align-items: center;
                border-radius: 4.537vw;
            }
        }
    }
</style>
